import React, { useRef, useState, useEffect } from 'react';
import { Button, Divider, Input, Layout, Menu, Typography, Drawer, Select } from 'antd';
import Icon, {
  CreditCardOutlined,
  GlobalOutlined,
  HomeOutlined,
  LeftOutlined,
  MenuOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Globe } from 'react-feather';

import version from '../../../package.json';

import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../store/actions/authActions';
import { Link, useHistory } from 'react-router-dom';
import { Default, Mobile } from '../../utils/media-query';

import NProgress from 'nprogress';

import { editFormSettings } from '../../store/actions/formActions';

import { useTranslation } from 'react-i18next';
import './styles.less';
import SubMenu from 'antd/lib/menu/SubMenu';
import { LANGUAGES } from '../../constants';
import { changeLanguage } from '../../store/actions/userActions';

import UpsellModal from '../UpsellModal';
import { Capacitor } from '@capacitor/core';

const platform = Capacitor.getPlatform();

const Navbar = ({ history, activeForm, drawerTitle, drawerContent }) => {
  const routerHistory = useHistory();

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const language = useSelector((state) => state.user.language);
  const { email, name } = useSelector((state) => state.auth.me);
  const [lang, setLang] = useState(language);

  const onLogOut = () => {
    dispatch(logoutUser(history));
  };

  useEffect(() => {
    if (email) {
      window.helpcenter = window.helpcenter || {};
      window.helpcenter.ready = function () {
        window.helpcenter.setUserData({ email, name: name ? name : '' });
      };
    }
  }, [email, name]);

  const selectLang = (e) => {
    if (!e.key) return;
    setLang(e.key);
    dispatch(changeLanguage({ language: e.key }));
  };

  const handleLanguageChange = (value) => {
    setLang(value);
    dispatch(changeLanguage({ language: value }));
  };

  const [formName, setFormName] = useState(activeForm?.name || '');
  const [editFormName, setEditFormName] = useState(false);
  const [isEditFormNameLoading, setEditFormNameLoading] = useState(false);
  const nameInputRef = useRef(null);

  const updateFormName = (e) => {
    if (activeForm.name === e.target.value) {
      setEditFormName(false);
      return;
    }
    setEditFormNameLoading(true);
    NProgress.start();
    dispatch(
      editFormSettings(activeForm.id, {
        name: e.target.value ?? 'Untitled',
        link: activeForm.link,
        language: activeForm.language,
        whatsappNumber: activeForm.whatsappNumber,
      }),
    ).then((e) => {
      setEditFormName(false);
      setEditFormNameLoading(false);
      NProgress.done();
    });
  };

  const menu = (
    <Menu key="user" mode="horizontal" selectable={false} disabledOverflow={true}>
      <SubMenu key="1" icon={<GlobalOutlined />} title={lang?.toUpperCase()}>
        {LANGUAGES.slice(0, 4).map((lang) => (
          <Menu.Item key={lang.code} onClick={selectLang}>
            {lang.name}
          </Menu.Item>
        ))}
      </SubMenu>
      <Menu.Item key="2" className="profile-avatar">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            if (window.helpcenter) window.helpcenter.toggle();
          }}
        >
          {t('common.help', 'Help')}
        </a>
      </Menu.Item>
      <SubMenu key="3" title={t('common.account', 'Account')}>
        {/* <Link to="/billing"> */}
        <Menu.Item key="profile" onClick={() => routerHistory.push('/account')}>
          {t('common.profile', 'Account Settings')}
        </Menu.Item>
        <Menu.Item key="billing" onClick={() => routerHistory.push('/billing')}>
          {t('common.billing', 'Billing')}
        </Menu.Item>
        {/* </Link> */}
        <Menu.Item key="4" onClick={onLogOut}>
          {t('common.logout', 'Logout')}
        </Menu.Item>
      </SubMenu>
    </Menu>
  );

  const [settingsDrawerVisible, setSettingsDrawerVisible] = useState(false);

  return (
    <>
      <UpsellModal />
      <Layout.Header theme="light" className="header">
        <div className="left-container">
          {activeForm ? (
            <Button
              type="text"
              style={{
                marginBottom: 1,
              }}
              icon={<LeftOutlined />}
              onClick={() => routerHistory.push('/')}
            />
          ) : (
            <Link to="/">
              {platform === 'web' ? (
                <img src={'/logo.png'} style={{ height: '20px' }} />
              ) : (
                <img src={'/whatsform-biz.png'} style={{ height: '30px' }} />
              )}
            </Link>
          )}
          <div className="navbar-form-title">
            {!editFormName && (
              <Typography.Text
                style={{ cursor: 'pointer' }}
                title={activeForm?.name}
                onClick={() => {
                  setEditFormName(true);
                  setTimeout(() => {
                    nameInputRef.current?.focus({
                      cursor: 'all',
                    });
                  });
                }}
              >
                {activeForm?.name}
              </Typography.Text>
            )}
            {editFormName && (
              <Input
                ref={nameInputRef}
                value={formName}
                onChange={(e) => setFormName(e.target.value)}
                onBlur={updateFormName}
                onPressEnter={updateFormName}
                size="medium"
                disabled={isEditFormNameLoading}
              />
            )}
          </div>
        </div>
        <div className="right-container">
          <Default>{menu}</Default>
          <Mobile>
            {' '}
            <Button
              onClick={() => setSettingsDrawerVisible(!settingsDrawerVisible)}
              icon={<MenuOutlined />}
              type="text"
              style={{ height: '50px', width: '50px' }}
            />
          </Mobile>
        </div>
      </Layout.Header>
      <Drawer
        title={drawerTitle || 'Settings'}
        placement="right"
        closable={true}
        onClose={() => setSettingsDrawerVisible(!settingsDrawerVisible)}
        visible={settingsDrawerVisible}
        getContainer={false}
        width="75%"
        className="settings-drawer"
        headerStyle={{ padding: '20px 20px 16px' }}
      >
        {drawerContent || (
          <>
            <Menu selectable={false} disabledOverflow={true}>
              {/* <Link to="/billing"> */}
              <Menu.Item key="profile" onClick={() => routerHistory.push('/account')}>
                {t('common.profile', 'Profile')}
              </Menu.Item>

              <Menu.Item key="billing" onClick={() => routerHistory.push('/billing')}>
                {t('common.billing', 'Billing')}
              </Menu.Item>
            </Menu>

            <Menu selectable={false} disabledOverflow={true}>
              <Divider />

              <Menu.Item key="language">
                <Select
                  optionLabelProp="label"
                  value={lang}
                  onChange={handleLanguageChange}
                  style={{ width: 200 }}
                >
                  {LANGUAGES.slice(0, 4).map((lang) => (
                    <Select.Option
                      key={lang.code}
                      value={lang.code}
                      label={
                        <div>
                          <GlobalOutlined style={{ marginRight: 10 }} /> {lang.name}
                        </div>
                      }
                    >
                      {lang.name}
                    </Select.Option>
                  ))}
                </Select>
              </Menu.Item>
              <Menu.Item key="help" className="profile-avatar">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (window.helpcenter) window.helpcenter.toggle();
                  }}
                >
                  {t('common.help', 'Help')}
                </a>
              </Menu.Item>

              <Menu.Item key="logout" onClick={onLogOut}>
                {t('common.logout', 'Logout')}
              </Menu.Item>
              <Menu.Item key="version">
                <Typography.Text type="secondary">Version {version.version}</Typography.Text>
              </Menu.Item>
            </Menu>
          </>
        )}
      </Drawer>
    </>
  );
};

export default Navbar;
